import './wdyr';
import React from 'react';
import ReactDOM from 'react-dom';
import './sentry';
import { LicenseInfo } from '@mui/x-license-pro';
import { LDProvider } from 'launchdarkly-react-client-sdk';
import { App } from './modules/App';
import { SessionContextProvider } from './modules/session';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import 'typeface-poppins';
import config from './config';

LicenseInfo.setLicenseKey(
  '5222418aa23dd79b6d4843a6cf5ff023Tz00ODY0NixFPTE2OTEzNTQ4ODE4ODQsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI='
);

window.version = '0.0.0';

if (window.location.host === 'ti.replicon.com') {
  window.location.href = window.location.href.replace(
    'https://ti.replicon.com/',
    'https://zt.replicon.com/'
  );
}

window.addEventListener('load', () => {
  const versionMeta: HTMLMetaElement | null = window.document.querySelector(
    'meta[name="version"]'
  );
  window.version = versionMeta?.content || window.version;
});

ReactDOM.render(
  <LDProvider clientSideID={config.ldClientId}>
    <SessionContextProvider>
      <App />
    </SessionContextProvider>
  </LDProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
